module.exports = __webpack_public_path__ + "static/media/home-entrance-3.6b0e3b4a.png";